/**
 * Enums for billing payment methods.
 */
export enum PaymentMethod {
  UNKNOWN = 'UNKNOWN',
  CARD = 'CARD',
  ACH = 'ACH',
  PATIENT = 'PATIENT',
  CASH = 'CASH'
}